import { NgModule } from '@angular/core';

import { AppHeightDirective } from './app-height.directive';
import { FeatureFlagDirective } from './feature-flag.directive';
import { MediaQueryAttributeDirective } from './mediaquery-attr.directive';
import { ResizeObserverDirective } from './resize-observer.directive';
import { SMAutofocusDirective } from './sm-autofocus.directive';
import { TemplateStoreDirective } from './template-store.directive';

const DIRECTIVES = [
  AppHeightDirective,
  FeatureFlagDirective,
  MediaQueryAttributeDirective,
  SMAutofocusDirective,
  TemplateStoreDirective,
];

// ResizeObserverDirective is standalone so components outside an NgModule can use it. A standalone
// directive is imported rather than declared, and re-exported so module consumers are unaffected.
@NgModule({
  imports: [ResizeObserverDirective],
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES, ResizeObserverDirective]
})
export class DirectiveModule { }
